import { render, staticRenderFns } from "./film.vue?vue&type=template&id=673b6baf&scoped=true&"
import script from "./film.vue?vue&type=script&lang=js&"
export * from "./film.vue?vue&type=script&lang=js&"
import style0 from "./film.vue?vue&type=style&index=0&id=673b6baf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b6baf",
  null
  
)

export default component.exports